import { stockUpload } from 'Service/ApiService';
import { useRef, useState } from 'react';
import { showAlert } from 'utils/ErrorMessage';
// import { barcodeUpload } from 'Service/ApiService';

const StockUploadController = () => {
  const fileInputRef = useRef(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [severity, setseverity] = useState();
  const [message, setmessage] = useState();
  const [alert, setAlert] = useState(false);

  const handleFileChange = (event) => {
    setAlert(false);
    const file = event.target.files[0];
    const fileExtension = file.name.split('.').pop().toLowerCase();
    // console.log("fileExtension",fileExtension)
    if (fileExtension === 'csv') {
      const now = new Date();
      const date = now.toLocaleDateString('en-CA'); // Format: YYYY-MM-DD
      const time = now.toLocaleTimeString('en-GB').replace(/:/g, '-'); // Format: HH-MM-SS

      const newFileName = `StockUpload_${date}_${time}.csv`;

      // Create a new file with the desired name
      const newFile = new File([file], newFileName, { type: file.type });

      setSelectedFile(newFile);
    } else {
      event.target.value = ''; // Clear the file input
      setSelectedFile(null);
      clearFileInput(); // Clear the selected file state
      showAlert('Please upload a CSV file', 'Validation');
    }
  };

  const clearFileInput = () => {
    if (fileInputRef.current) {
      fileInputRef.current.value = ''; // Reset the value of the file input
    }
  };

  const handleUpload = async (e) => {
    e.preventDefault();
    try {
      setAlert(false);
      if (selectedFile) {
        setLoading(true);
        const user = JSON.parse(localStorage.getItem('user'));
        const response = await stockUpload(selectedFile, user.userCode);
        // console.error('Return Response:', response);
        if (response && response.success === 'true') {
          setmessage(response.msg);
          setseverity('green');
          setAlert(true);
        } else {
          setmessage(response.msg);
          setseverity('red');
          setAlert(true);
        }
        setLoading(false);
        setTimeout(() => {
          setSelectedFile(null);
          clearFileInput();
          setAlert(false);
        }, 5000);
      } else {
        setmessage('Please select a file to upload');
        setseverity('red');
        setAlert(true);
      }
    } catch (error) {
      setLoading(false);
      // console.error('Error during login:', error);
    }
  };

  return {
    loading,
    handleFileChange,
    handleUpload,
    fileInputRef,
    severity,
    message,
    alert
  };
};

export default StockUploadController;
